module.exports = __webpack_public_path__ + "assets/img/bg-8fc40369.jpg";